import { render } from "./LayoutPage.vue?vue&type=template&id=22a6afae"
import script from "./LayoutPage.vue?vue&type=script&lang=js"
export * from "./LayoutPage.vue?vue&type=script&lang=js"

import "./LayoutPage.vue?vue&type=style&index=0&id=22a6afae&lang=css"

import exportComponent from "D:\\Project\\RDD_METE\\METE_OUTLET_WEB\\METE_WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__